import { Outlet } from 'react-router-dom';
import Gnb from '@/components/organisms/Gnb';
import Footer from '@/components/organisms/Footer';
import { useResponsive } from '@/hooks/useResponsive';
import { cn } from '@/utils/tailwind';
import { MembershipContentLock } from '@/components/membership/MembershipContentLock';
import { useMembershipPreviewAccess } from '@/hooks/useMembershipPreviewAccess';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

const Rootlayout = ({ bgColor, isViewFooter }: RootlayoutProps) => {
  bgColor = bgColor ? bgColor : 'bg-gr-50';
  const { isPCSize } = useResponsive();
  const shouldShowMembershipPreview = useMembershipPreviewAccess();

  return (
    <div className={`min-h-[100vh] ${bgColor}`}>
      {isPCSize && <Gnb />}
      <div className={cn(isPCSize ? 'w-max-[1920px] container w-[1920px]' : '')}>
        <MembershipContentLock isLocked={shouldShowMembershipPreview}>
          <Outlet />
        </MembershipContentLock>
      </div>
      {isViewFooter && <Footer />}
    </div>
  );
};

export default Rootlayout;
